import Constants from "../constants/constants";
import { Company } from "../models/Company";
import { UserWithRole } from "../models/UserWithRole";

export function getFamFromCompany(company: string): string | null {
  // if company is less than 3 characters, it's not a valid company
  if (company.length < 3) {
    return null;
  }

  // if company is 5 characters and starts with CP or AC, it's a customer center and FAM is the last 3 characters
  // otherwise it's a customer and FAM is the first 3 characters
  const parent = company.substring(0, 2);
  const isCpOrAcCustomerCenter = parent === "CP" || parent === "AC";
  if (company.length > 5 && !isCpOrAcCustomerCenter) {
    return company.substring(0, 3);
  }

  return company.substring(3, 5);
}

/**
 * Returns the service email to refer to when the selected customer has been migrated from Indysoft
 * to Salesforce, or null when WIMT is not blocked. Only external users (User / Distributor / Indirect Customer) are affected.
 */
export function getSalesforceMigrationContactEmail(
  user: UserWithRole,
  company: Company,
): string | null {
  if (!user?.isUserGroupProfile || !company?.name) {
    return null;
  }

  const fam = getFamFromCompany(company.name);
  return Constants.SALESFORCE_MIGRATED_FAM_CONTACT_EMAILS[fam] ?? null;
}

/** Determines whether WIMT must be blocked because the selected customer has been migrated to Salesforce. */
export function isBlockedBySalesforceMigration(user: UserWithRole, company: Company): boolean {
  return getSalesforceMigrationContactEmail(user, company) !== null;
}
